import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, Container, Typography } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
Page404.propTypes = {
  firstLogin: PropTypes.bool,
};
export default function Page404({ firstLogin }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title> {t('pages.404.404NotFound')} </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            {t('pages.404.pageNotFound')}
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            {t('pages.404.couldntFindPage')}
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />
          {firstLogin ? (
            <Button to="/login" size="large" variant="contained" component={RouterLink}>
              {t('pages.login.backToLogin')}
            </Button>
          ) : (
            <Button to="/" size="large" variant="contained" component={RouterLink}>
              {t('pages.404.goToHome')}
            </Button>
          )}
        </StyledContent>
      </Container>
    </>
  );
}
